import React from 'react'
import { Link } from 'react-router-dom'
import about from '../Image/company-about.png'

function Aboutus() {
    return (
        <>
            <section className="breadcrumb-area banner-1" data-background="images/banner/9.jpg">
                <div className="text-block">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 v-center">
                                <div className="bread-inner">
                                    <div className="bread-menu">
                                        <ul>
                                            <li><Link to="/">Home</Link></li>
                                            <li><a href="#">About Us</a></li>
                                        </ul>
                                    </div>
                                    <div className="bread-title">
                                        <h2>About Us</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="about-agency pad-tb block-1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 v-center">
                            <div className="about-image">
                                <img src={about} alt="about us" className="img-fluid" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="common-heading text-l ">
                                <span>About Us</span>
                                <h2>About N D Techland</h2>
                                <p style={{ textAlign: "justify" }}>N D Techland(sister concern of N D Infotech) is appraised as one of the top web development agencies in India by different industry magazines and survey destinations. We have a correct mix of grant winning designers, master web designers which make us a special one-stop answer for many our customers, spread across 80+ nations. we're obsessed on quality. We depend on our portfolio to work together and consistently guarantee that every one of our web or mobile deliverable is remarkable and world class. </p>
                                <p style={{ textAlign: "justify" }}>As a best web development organization in India, we have devoted group of expert developers and designers, making amazing and creative websites. We utilize ultra clean and bold design style to give standard based markup code to your website that brag excellent Google result positions, help increment changes. As Web Development company, we accept that a decent online presence begins with an incredible site. Your business site isn't only a virtual portrayal of your organization profile. But it reflects your business targets and objectives.</p>
                            </div>
                            <div className="row in-stats small about-statistics">
                                <div className="col-lg-4 col-sm-4">
                                    <div className="statistics">
                                        <div className="statnumb counter-number">
                                            <span className="counter">450</span>
                                            <p>Happy Clients</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-sm-4">
                                    <div className="statistics">
                                        <div className="statnumb">
                                            <span className="counter">95</span><span>k</span>
                                            <p>Hours Worked</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-sm-4">
                                    <div className="statistics mb0">
                                        <div className="statnumb counter-number">
                                            <span className="counter">850</span>
                                            <p>Projects Done</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="why-choose pad-tb">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <div className="common-heading">
                                <span>We Are Awesome</span>
                                <h2 className="mb30">Why Choose Us</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row upset">
                        {[
                            {
                                icon: "images/icons/research.svg",
                                title: "Research and Analysis",
                                text: "Our research and development team always finds what's best for a website.",
                            },
                            {
                                icon: "images/icons/chat.svg",
                                title: "Negotiation and Power",
                                text: "Negotiation is not a priority if you got powerful and best quality products.",
                            },
                            {
                                icon: "images/icons/monitor.svg",
                                title: "Creative and Innovative Solutions",
                                text: "We always provide the most innovative and creative ideas to our clients.",
                            },
                            {
                                icon: "images/icons/trasparency.svg",
                                title: "Transparency and Ease of Work",
                                text: "From start to end of the project, everything is transparent and every step is in knowledge of our clients.",
                            },
                            {
                                icon: "images/icons/support.svg",
                                title: "24/7 Support",
                                text: "We provide round-the-clock support to ensure smooth operations for our clients.",
                            },
                            {
                                icon: "images/icons/growth.svg",
                                title: "Focus on Growth",
                                text: "We aim to deliver solutions that ensure long-term growth and sustainability.",
                            },
                        ].map((item, index) => (
                            <div key={index} className="col-lg-4 col-sm-6 mt30 d-flex">
                                <div className="s-block up-hor flex-fill">
                                    <div className="s-card-icon">
                                        <img src={item.icon} alt={item.title} className="img-fluid" />
                                    </div>
                                    <h4>{item.title}</h4>
                                    <p>{item.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

export default Aboutus